var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVisionIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "eye-solid 1",
    clipPath: "url(#clip0_2649_660)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M14.0007 1.75C10.073 1.75 6.92782 3.7625 4.63824 6.15781C2.36324 8.53125 0.84171 11.375 0.122266 13.3273C-0.038151 13.7594 -0.038151 14.2406 0.122266 14.6727C0.84171 16.625 2.36324 19.4688 4.63824 21.8422C6.92782 24.2375 10.073 26.25 14.0007 26.25C17.9285 26.25 21.0737 24.2375 23.3632 21.8422C25.6382 19.4633 27.1598 16.625 27.8841 14.6727C28.0445 14.2406 28.0445 13.7594 27.8841 13.3273C27.1598 11.375 25.6382 8.53125 23.3632 6.15781C21.0737 3.7625 17.9285 1.75 14.0007 1.75ZM7.00074 14C7.00074 11.9114 7.73824 9.90838 9.05099 8.43153C10.3637 6.95469 12.1442 6.125 14.0007 6.125C15.8573 6.125 17.6377 6.95469 18.9505 8.43153C20.2632 9.90838 21.0007 11.9114 21.0007 14C21.0007 16.0886 20.2632 18.0916 18.9505 19.5685C17.6377 21.0453 15.8573 21.875 14.0007 21.875C12.1442 21.875 10.3637 21.0453 9.05099 19.5685C7.73824 18.0916 7.00074 16.0886 7.00074 14ZM14.0007 10.5C14.0007 12.4305 12.6056 14 10.8896 14C10.5445 14 10.2139 13.9344 9.90282 13.8195C9.63546 13.7211 9.32435 13.907 9.33407 14.2242C9.34865 14.6016 9.39727 14.9789 9.48963 15.3562C10.1556 18.1562 12.7174 19.8188 15.2063 19.0695C17.6952 18.3203 19.173 15.4383 18.507 12.6383C17.9674 10.3688 16.1834 8.84297 14.2 8.75C13.9181 8.73906 13.7528 9.08359 13.8403 9.38984C13.9424 9.73984 14.0007 10.1117 14.0007 10.5Z",
    fill: "#6210CC"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2649_660"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisionIcon);
export default __webpack_public_path__ + "static/media/vision_icon.2bff8cedc11b0969d28ad2ac46063331.svg";
export { ForwardRef as ReactComponent };